var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDCoolingRoomBalancingValves = function SvgDCoolingRoomBalancingValves(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 204.96,
    y: 249,
    width: 10,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "209.94 264.01 217.09 276.49 202.82 276.5 209.94 264.01",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.94,265.02l6.29,10.97h-12.55s6.26-10.97,6.26-10.97M209.94,263l-7.98,14h16s-8.01-14-8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "202.82 249.51 217.09 249.5 209.94 261.99 202.82 249.51",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.23,250l-6.29,10.98-6.26-10.98h12.55M217.95,249h-16s7.98,14,7.98,14l8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "220.36 269.17 205.72 259.59 206.4 258.55 200 256.45 204.49 261.47 205.17 260.42 219.82 270 220.36 269.17",
    fill: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 398.96,
    y: 249,
    width: 10,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "403.94 264.01 411.09 276.49 396.82 276.5 403.94 264.01",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.94,265.02l6.29,10.97h-12.55s6.26-10.97,6.26-10.97M403.94,263l-7.98,14h16s-8.01-14-8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "396.82 249.51 411.09 249.5 403.94 261.99 396.82 249.51",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.23,250l-6.29,10.98-6.26-10.98h12.55M411.95,249h-16s7.98,14,7.98,14l8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "414.36 269.17 399.72 259.59 400.4 258.55 394 256.45 398.49 261.47 399.17 260.42 413.82 270 414.36 269.17",
    fill: "#1d1d1b"
  })))));
};
export default SvgDCoolingRoomBalancingValves;